<template>
    <section class="common-fix-bg select-area" @click.self="close">
        <div class="wrap">
            <span class="close-this"></span>
            <div class="tit">{{title}}</div>
			<ul class="list-wrap" v-if='type == "address"'>
				<li class="list-item bBor" :class="flag==index?'current':''" v-for="(item,index) in selectData" @click="selectItem(item,index)">{{item.areaName}}</li>
			</ul>
			
			<ul class="list-wrap" v-else>
				<li class="list-item bBor" :class="flag==index?'current':''" v-for="(item,index) in selectData" @click="selectItem(item,index)">{{item.value}}</li>
			</ul>
			
        </div>
    </section>
</template>

<script>
export default {
	data(){
	    return {
			flag:-1
	    }
	},
	
	props:{
		selectData:{
			type:Array,
			default:()=>[]
		},
		title:{
			type:String,
			default:"education"
		},
		type:{
			type:String,
			default:"education"
		}
	},
	
	methods:{
		selectItem(item,index){
			this.flag = index;
			if(this.type == "address"){
				this.$emit("comfirmAddress",item);
			}
			else{
				this.$emit("selectItem",item);
			}
		},
		close(){
			this.$emit("close")
		}
	}
}
</script>

<style scoped>

.common-fix-bg {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, .7);
    z-index: 10
}

.common-fix-bg .wrap {
    position: absolute;
    width: 7.5rem;
    left: 50%;
    margin-left: -3.75rem;
    background: #fff
}

.common-fix-bg .wrap .close-this {
    position: absolute;
    width: .28rem;
    height: .27rem;
    /* background: url(../assets/img/buttonSelect/bill_detail_close.png) center/contain no-repeat; */
    background-size: contain
}

.select-area .wrap,
.select-wrap .wrap {
    /* min-height: 2.6rem; */
    bottom: 0
}

.select-area .wrap .close-this,
.select-wrap .wrap .close-this {
    top: .31rem;
    right: .2rem
}

.select-area .wrap .tit,
.select-wrap .wrap .tit {
    height: .9rem;
    line-height: .9rem;
    border-bottom: .02rem solid #ED7D31;
    color: #999;
    font-size: .28rem;
    text-align: center
}

.select-area .wrap .list-item,
.select-wrap .wrap .list-item {
    overflow: hidden;
    position: relative;
    height: .9rem;
    line-height: .9rem;
    color: #363636;
    font-size: .28rem;
    text-align: center;
    display: block;
}

.select-area .wrap .list-item.select,
.select-wrap .wrap .list-item.select {
    color: #ED7D31
}

.select-area .wrap .list-item:last-child::after,
.select-wrap .wrap .list-item:last-child::after {
    display: none
}

.select-area .wrap .list-item .check-flag,
.select-wrap .wrap .list-item .check-flag {
    display: inline-block;
    width: .32rem;
    height: .8rem;
    margin-left: .2rem;
    /* background: url(../assets/img/buttonSelect/selected_city.png) center/cover no-repeat; */
    background-size: cover;
    vertical-align: top
}

.select-area .list-wrap {
    overflow: auto;
    max-height: 6.8rem;
    width: 100%;
}
.bBor::after {
    position: absolute;
    content: "";
    height: 1px;
    background: #e1e1e1;
    left: 0;
    right: 0;
    bottom: 0;
}
.select-area .wrap .current{
	background-color: #ED7D31;
	color: #FFF;
}
</style>



